import React, { useState, useEffect } from 'react';
import { Line, Bar,Pie } from 'react-chartjs-2';

import { fetchDailyData } from '../../api';

import styles from './Chart.module.css';
import { Button } from '@material-ui/core';
import {BeatLoader} from 'react-spinners'

const Chart = ({ data: { confirmed, recovered, deaths }, country,x }) => {
  const [dailyData, setDailyData] = useState({});

  useEffect(() => {
    const fetchMyAPI = async () => {
      const initialDailyData = await fetchDailyData();

      setDailyData(initialDailyData);
    };

    fetchMyAPI();
  }, []);

  const barChart = (
      confirmed ? (
      <Bar className={styles.bar1}
        data={{
          labels: ['Infected', 'Recovered', 'Deaths'],
          datasets: [
            {
              label: 'People',
              backgroundColor: ['red', 'green', 'black'],
              data: [confirmed.value, recovered.value, deaths.value],
            },
          ],
        }}
        options={{
          legend: { display: false },
          title: { display: true, text: `Current state in ${country}` },
        }}
      />
    ) : null

  

  );

  const lineChart = (
    dailyData[0] ? (
      <Line
        data={{
          labels: dailyData.map(({ date }) => new Date(date).toLocaleDateString()),
          datasets: [{
            data: dailyData.map((data) => data.confirmed),
            label: 'Infected',
            borderColor: 'red',
            fill: true,
          }, {
            data: dailyData.map((data) => data.deaths),
            label: 'Deaths',
            borderColor: 'black',
            fill: true,
          },  {
            data: dailyData.map((data) => data.recovered),
            label: 'Recovered',
            borderColor: 'green',
            backgroundColor: 'rgba(0, 255, 0, 0.5)',
            fill: true,
          },
          ],
        }}
      />
    ) : null
  );


  //pie chart
  const pieChart=(
    confirmed?(
      <Pie
        data={{
          labels: ['Infected', 'Recovered', 'Deaths'],
          datasets: [
            {
              label: 'People',
              backgroundColor: ['red', 'green', 'black'],
              data: [confirmed.value, recovered.value, deaths.value],
              radius:'50%',
            },
          ],
        }}
        options={{
          legend: { display: false },
          title: { display: true, text: `Current state in ${country}` },
        }}
      />
    ): null 
    
  )

  return (
    <div className={styles.container}>
      {country ? (x?barChart: pieChart) : lineChart}
    </div>
  );
};

export default Chart;